const ACCESS_OPTIONS = [
  { key: 'viewer', label: 'Carpool Viewer' },
  { key: 'manager', label: 'Carpool Manager' },
];

export default function StaffAccessLevelCard({ activeLevel = 'viewer', onSelect, disabled = false }) {
  return (
    <div className="sap-section-card sat-access-card">
      <div className="sat-access-title">Control access level for this staff member</div>
      <p className="sat-access-copy">
        Carpool Viewers can monitor dismissal activity and track students in real time, but cannot make any changes.
        Carpool Managers have full control over the dismissal process, including calling students, confirming pickups,
        and managing the flow of the carpool line.
      </p>

      <div className="sat-access-actions">
        {ACCESS_OPTIONS.map((option) => {
          const isActive = activeLevel === option.key;

          return (
            <button
              key={option.key}
              type="button"
              className={`sat-access-option ${isActive ? 'active' : ''}`}
              onClick={() => onSelect?.(option.key)}
              disabled={disabled}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
